export default "A\nB\nC\nÇ\nD\nE\nF\nG\nĞ\nH\nI\nİ\nJ\nK\nL\nM\nN\nO\nÖ\nP\nR\nS\nŞ\nT\nU\nÜ\nV\nY\nZ"